/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$('.flexslider').flexslider({
    controlNav: false,
    slideshowSpeed: 3000,
});


$('.zoom').magnify();
